import apiService from 'src/utils/apiService';
import * as types from '../mutation-types';


// initial state
const state = {
  chartData1: [],
  chartData2: [],
  chartRange: '1d',
  chartType: 'price',
  test: null,
};

// getters
const getters = {
  chartOptions(state, getters, rootState, rootGetters) { //eslint-disable-line
    return {
      range: state.chartRange,
      chartType: state.chartType,
      currencyCode: rootGetters['userData/currencyCode'],
    };
  },
};

const formatChartData = d => ({ x: new Date(d.x), y: d.y });

// actions
const actions = {
  updateChart({ commit, getters }, chartOptions) { // eslint-disable-line
    return apiService.getChartBigData(chartOptions).then((data) => {
      commit(types.UPDATE_CHART_DATA, data);
    });
  },
  setChartOptions({ commit }, options) {
    return commit(types.UPDATE_CHART_OPTIONS, options);
  },
};

// mutations
const mutations = {
  [types.UPDATE_CHART_DATA](s, { value, volume }) {
    s.chartData1 = value.map(formatChartData); // eslint-disable-line
    s.chartData2 = volume.map(formatChartData); // eslint-disable-line
  },

  [types.UPDATE_CHART_OPTIONS](s, { range, chartType, currencyCode, tickerId }) {
    s.test = { range, chartType, currencyCode, tickerId  }; // eslint-disable-line
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/currencyPage.js